module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register_box",
    attrs: {
      "id": "register_page"
    }
  }, [_c('h4', {
    staticClass: "color_5babf4 login_title"
  }, [_vm._v("注册新账号")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#",
      "method": ""
    }
  }, [_c('div', {
    staticClass: "register_user login_mbtm6"
  }, [_c('label', {
    staticClass: "label_focus",
    attrs: {
      "for": "register_mob"
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.mobile),
      expression: "user.mobile",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input_focus login_form",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": "register_mob",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.user.mobile)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.reg.apply(null, arguments)
      },
      "blur": [function($event) {
        return _vm.checkMobile();
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "mobile", $event.target.value.trim())
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "password login_mbtm6"
  }, [_c('label', {
    staticClass: "label_focus",
    attrs: {
      "for": "register_pwd"
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.password),
      expression: "user.password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input_focus login_form",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "id": "register_pwd"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.reg.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "forget_yzm login_mbtm6"
  }, [_c('label', {
    staticClass: "label_focus",
    attrs: {
      "for": "register_yzm"
    }
  }, [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.yzm),
      expression: "user.yzm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control inline-block input_focus login_form",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": "register_yzm"
    },
    domProps: {
      "value": (_vm.user.yzm)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.reg.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "yzm", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "yzm_box inline-block"
  }, [_c('img', {
    attrs: {
      "id": "verifyImg1"
    },
    on: {
      "click": function($event) {
        return _vm.fleshVerify()
      }
    }
  })]), _vm._v(" "), _c('i', {
    staticClass: "glyphicon icon_reload",
    attrs: {
      "id": "cloudFreshenThree"
    },
    on: {
      "click": function($event) {
        return _vm.fleshVerify()
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "login_btn_box"
  }, [_c('a', {
    staticClass: "btn btn_h btn_issue margin_r_7",
    attrs: {
      "href": "javascript:void(0);",
      "id": "ypt_register"
    },
    on: {
      "click": function($event) {
        return _vm.reg()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('small', {
    staticClass: "color_9"
  }, [_vm._v("已有账号，"), _c('router-link', {
    staticClass: "color_308de2",
    attrs: {
      "to": "/login_page"
    }
  }, [_vm._v("立即登录")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tip_box kfzreg-hide"
  }, [_c('small', {
    staticClass: "tip_yz regcontent"
  }, [_vm._v("密码错误！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-115decbb"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/loginGroup/register_page.vue
// module id = 1238
// module chunks = 1